export const copy = {
	anonymizedField: 'ANONYMIZED',
	paymentMessage: (userId: number): string => `Inbetalning (${userId})`,
	withdrawStatement: 'MyBonus.com',
	withdrawalReview: {
		message: 'Din utbetalning är under granskning.',
		details: 'Du kommer bli notifierad när vi behandlat din utbetalning.',
	},
	ongoingWithdrawal: {
		message: 'Du har redan en pågående utbetalning.',
		details: 'Testa igen lite senare.',
	},
	deniedWithdrawal: {
		message: 'Din utbetalning godkändes inte.',
		details: 'Vänligen kontakta kundtjänst för mer information.',
	},
	noName: 'Namnlös',
	upTo: 'Upp till',
	personalCashbackShare: 'Personlig höjning',
	offerwallGate: {
		eyebrow: 'Så fungerar det',
		title: 'Ladda ner spel och appar – få cashback',
		description:
			'Upptäck spel och appar som du kan ladda ner till mobilen. Följ villkoren i erbjudandet och få cashback när du når de angivna målen.',
		steps: [
			{
				title: 'Välj ett spel eller en app',
				text: 'Identifiera dig med BankID och se vilka spel och appar som finns tillgängliga för dig.',
			},
			{
				title: 'Ladda ner och spela',
				text: 'Läs instruktionerna och ladda ner erbjudandet. Du kan till exempel få cashback när du installerar, spelar eller når en viss nivå i ett spel.',
			},
			{
				title: 'Få cashback',
				text: 'När partnern bekräftar att du har klarat målet registreras din cashback på ditt MyBonus-konto.',
			},
		],
		ctaReason: 'Identifiera dig med BankID för att se dina erbjudanden och komma igång.',
	},
	offerwallUnavailable: {
		eyebrow: 'Erbjudanden',
		title: 'Erbjudanden är inte tillgängliga just nu',
		description:
			'Det går inte att öppna erbjudanden för ditt konto just nu. Du kan fortfarande använda MyBonus som vanligt under tiden.',
	},
	audienceBuilder: {
		BOOL: {
			UNSET: 'Unset',
			TRUTHY: 'True',
			FALSY: 'False',
		},
		DATE: {
			UNSET: 'Unset',
			EQ: 'Equals',
			NEQ: 'Not equals',
			GT: 'After',
			GTE: 'After or on',
			LT: 'Before',
			LTE: 'Before or on',
			IN_THE_LAST: 'In the last',
			MORE_THAN: 'More than',
			INSIDE: 'Between',
			OUTSIDE: 'Not between',
		},
		NUMBER: {
			INSIDE: 'Between',
			OUTSIDE: 'Not between',
			UNSET: 'Unset',
			TRUTHY: 'Non-zero',
			FALSY: 'Zero or not set',
			EQ: 'Equals',
			NEQ: 'Not equals',
			GT: 'Greater than',
			GTE: 'Greater than or equal to',
			LT: 'Less than',
			LTE: 'Less than or equal to',
		},
		SELECT: {
			INCLUDES: 'Includes',
			EXCLUDES: 'Excludes',
		},
		TEXT: {
			UNSET: 'Unset',
			TRUTHY: 'Is set',
			STARTS_WITH: 'Starts with',
			ENDS_WITH: 'Ends with',
			CONTAINS: 'Contains',
			EQ: 'Equals',
			NEQ: 'Not equals',
		},
	},
};
